import { render, staticRenderFns } from "./PanelHeader.vue?vue&type=template&id=a6f37d60&scoped=true&"
import script from "./PanelHeader.vue?vue&type=script&lang=js&"
export * from "./PanelHeader.vue?vue&type=script&lang=js&"
import style0 from "./PanelHeader.vue?vue&type=style&index=0&id=a6f37d60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f37d60",
  null
  
)

export default component.exports